<template>
	<div class="tab-text bg-light-grey">

		<div class="grid grid-cols-12 gap-5">
			<h3 class="mb-4 col-span-3">Alternative Dates</h3>
			<div class="text-sm">Min ${{ result.totalPrice-50 }}</div>
			<div class="text-sm col-start-7 whitespace-no-wrap text-right">< cheaper</div>
			<div class="text-sm col-start-9 whitespace-no-wrap">costlier ></div>
			<div class="text-sm col-start-12">Max ${{ (result.totalPrice+500)*2 > result.totalPrice*4 ? (result.totalPrice+500)*2 : result.totalPrice*4 }}</div>
		</div>
		<div class="grid grid-cols-12 gap-0">
			<div class="col-start-4 col-span-9 triangle-20-100percent">
			</div>
		</div>

		<!-- <vs-row vs-w="12">
			<vs-col vs-offset="3" vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
				<div class="vx-card p-2 text-center">
					Interior<br>$699
				</div>
			</vs-col>
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
				<div class="vx-card p-2 text-center">
					Interior<br>$699
				</div>
			</vs-col>
		</vs-row> -->

		<div class="grid grid-cols-12 gap-5 border-t border-l-0 border-r-0 border-b-0 d-theme-border-grey-light border-solid py-3">
			<div class="col-span-3 text-right flex flex-wrap content-center">
				<span>{{ formatedRestultDate(-1) }}</span>
			</div>
			<div class="text-sm col-start-9 vx-card p-1 text-center">
				Interior<br>${{ result.totalPrice+200 }}
			</div>
			<div class="text-sm vx-card p-1 text-center">
				Ocean<br>${{ result.totalPrice+300 }}
			</div>
			<div class="text-sm vx-card p-1 text-center">
				Balcony<br>${{ result.totalPrice+500 }}	
			</div>
			<div class="text-sm vx-card p-1 text-center">
				Suite<br>${{ (result.totalPrice+500)*2 }}
			</div>
		</div>
			
		<!-- <div class="col-span-12" style="margin:0">
			<vs-divider class="my-3"></vs-divider>
		</div> -->

		<div class="current-selection grid grid-cols-12 gap-5 border-t border-l-0 border-r-0 border-b-0 d-theme-border-grey-light border-solid py-3">
			<div class="col-span-3 text-right flex flex-wrap content-center">
				<span>{{ formatedRestultDate(0) }} (current selection)</span>
			</div>
			<div class="text-sm col-start-8 vx-card bg-primary text-white p-1 text-center">
				Interior<br>${{ result.totalPrice }}
			</div>
			<div class="text-sm vx-card p-1 text-center">
				Ocean<br>${{ result.totalPrice+100 }}
			</div>
			<div class="text-sm vx-card p-1 text-center text-primary">
				Balcony<br>${{ result.totalPrice+100 }}	
			</div>
			<div class="text-sm vx-card p-1 text-center">
				Suite<br>${{ (result.totalPrice)*4 }}
			</div>
		</div>

		<!-- <div class="col-span-12">
			<vs-divider class="my-3"></vs-divider>
		</div> -->

		<div class="grid grid-cols-12 gap-5 border-t border-l-0 border-r-0 border-b-0 d-theme-border-grey-light border-solid py-3">
			<div class="col-span-3 text-right flex flex-wrap content-center">
				<span>{{ formatedRestultDate(1) }}</span>
			</div>
			<div class="text-sm col-start-7 vx-card p-1 text-center text-primary">
				Interior<br>${{ result.totalPrice-50 }}
			</div>
			<div class="text-sm vx-card p-1 text-center text-primary">
				Ocean<br>${{ result.totalPrice }}
			</div>
			<div class="text-sm vx-card p-1 col-start-10 text-center">
				Balcony<br>${{ result.totalPrice+200 }}	
			</div>
			<div class="text-sm vx-card p-1 text-center">
				Suite<br>${{ (result.totalPrice)*4 }}
			</div>
		</div>

		<!-- <div class="col-span-12">
			<vs-divider class="my-3"></vs-divider>
		</div> -->

		<div class="grid grid-cols-12 gap-5 border-t border-l-0 border-r-0 border-b d-theme-border-grey-light border-solid py-3">
			<div class="col-span-3 text-right flex flex-wrap content-center">
				<span>{{ formatedRestultDate(2) }}</span>
			</div>
			<div class="text-sm col-start-7 vx-card p-1 text-center text-primary">
				Interior<br>${{ result.totalPrice-50 }}
			</div>
			<div class="text-sm vx-card p-1 text-center text-primary">
				Ocean<br>${{ result.totalPrice }}
			</div>
			<div class="text-sm vx-card p-1 col-start-10 text-center">
				Balcony<br>${{ result.totalPrice+200 }}	
			</div>
			<div class="text-sm vx-card p-1 text-center">
				Suite<br>${{ (result.totalPrice)*4 }}
			</div>
		</div>

		<div class="pt-5 text-sm text-right">
			<div class="text-sm vx-card p-0 text-center w-6 inline-block bg-primary text-white">$</div><span class="text-primary ml-2">current choice</span>
			<div class="ml-5 text-sm vx-card p-0 text-center w-6 inline-block text-primary">$</div><span class="text-primary ml-2">good deals</span>
			<div class="ml-5 text-sm vx-card p-0 text-center w-6 inline-block">$</div><span class="ml-2">other alternatives</span>

		</div>

	</div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  methods: {
	  formatedRestultDate(month){
		let d = new Date(this.result.date);
		d.setMonth(d.getMonth() + month);
		return d.toLocaleString('en-US', { month: 'short', year: 'numeric', day: 'numeric' })
	  }
  }
}
</script>
